import React__default from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';
import { useIntl } from '@grandvisionhq/state';
import IconButton from '../../../IconButton/IconButton.js';
import { useDrawer } from '../../context/DrawerContext.js';

const DrawerHeader = ({ Title  })=>{
    const { getLabel  } = useIntl();
    const { close , direction  } = useDrawer();
    return /*#__PURE__*/ React__default.createElement("div", {
        className: classnames('drawer-header', `drawer-header--${direction}`)
    }, Title && /*#__PURE__*/ React__default.createElement(Title, {
        className: "drawer-header__title"
    }), /*#__PURE__*/ React__default.createElement(IconButton, {
        variant: "ghost",
        "aria-label": getLabel('common.actions.close'),
        onClick: close
    }, /*#__PURE__*/ React__default.createElement(Icon, {
        name: "close"
    })));
};

export { DrawerHeader };
//# sourceMappingURL=DrawerHeader.js.map
